/** Renders only server-resolved original source text; opening a disclosure performs no request. */
import type { ShopifyResultQuote } from '@testfeed/shopify-contracts'
import { ServerResultSourceLink } from './ServerResultSource'
import { SourceAnswerText } from './ServerResultSourceModal'

export function ServerOriginalExchange({ exchange }: { exchange: ShopifyResultQuote['originalExchange'] }) {
  if (!exchange) return null
  return (
    <details className="response-phrase-disclosure">
      <summary>{exchange.label}</summary>
      <s-stack direction="block" gap="large">
        <s-text color="subdued">{exchange.source}</s-text>
        {exchange.answers.map((answer) => (
          <s-stack direction="block" gap="small" key={answer.id}>
            <s-text color="subdued">{answer.originLabel}</s-text>
            <s-text type="strong">{answer.question}</s-text>
            <SourceAnswerText answer={answer} />
            <ServerResultSourceLink answerId={answer.id}>{exchange.sourceLinkLabel}</ServerResultSourceLink>
          </s-stack>
        ))}
      </s-stack>
    </details>
  )
}
